import { withLDProvider } from 'launchdarkly-react-client-sdk';
import { createRoot } from 'react-dom/client';

import {
  VITE_EQUIP_APPS_LAUNCH_DARKLY_CLIENT_SIDE_ID,
  VITE_MAUD_APP_VERSION,
} from '~/lib/constants/env';
import { WrappingContexts } from './WrappingContexts';
import { initDatadog } from './lib/util/datadog/datadog.util';

initDatadog();

const container = document.getElementById('root');
const root = createRoot(container);

const LDProvider = withLDProvider({
  clientSideID: VITE_EQUIP_APPS_LAUNCH_DARKLY_CLIENT_SIDE_ID,
  context: {
    key: 'equip-vesta',
    kind: 'organization',
  },
  options: {
    application: {
      id: 'equip-vesta',
      version: VITE_MAUD_APP_VERSION,
    },
  },
})(WrappingContexts);
root.render(<LDProvider />);
